<template>
	<div class="input__wrapper">
		<span class="radio-butons-title" :id="data.labelId">{{ data.label }}</span>
		<ul class="radio-butons">
			<li class="radio-butons-item" v-for="list in data.lists" :key="list.id">
				<input
					class="radio-list__input"
					type='radio'
					:id="list.id"
					:value="list.value"
					:name="list.name"
					v-model="inputVal"
					>
				<label class="radio-list__label" :for="list.for">
                    <span>{{ list.label }}</span>
                </label>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},

	data () {
		return {
			inputVal: this.data.defaultValue ? this.data.defaultValue : this.value
		};
	},

	watch: {
		inputVal (val) {
			this.$emit('input', val);
		}
	}
};
</script>
<style lang="scss" scoped>
.radio-butons-title {
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	color: $slate-gray;
	margin-bottom: 12px;
    display: block;
}

.radio-butons {
	display: flex;
	justify-content: space-between;
    align-items: center;
    position: relative;
    margin-bottom: 0;
}

.radio-butons-item {
	display: flex;
	align-items: center;
	position: relative;
	line-height: 25px;
    max-width: 47%;
    width: 100%;
}

.radio-list__label {
	font-family: $font-main;
	display: flex;
	color: $fiord;
	font-size: 14px;
	line-height: 20px;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    width: 100%;
	transition: $dur $ease;

    span {
        z-index: 5;
        position: relative;
        padding: 8px 20px;

        @include mq($sm) {
            padding: 8px 7px;
        }
    }

	@include hover {
		&:before {
			border: 1px solid $dodger-blue !important;
		}
	}
}

[type='radio']:checked,
[type='radio']:not(:checked) {
    position: absolute;
    left: -9999px;
}

[type='radio']:checked + label,
[type='radio']:not(:checked) + label {
    position: relative;
    cursor: pointer;
    line-height: 20px;
	transition: $dur $ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

[type='radio']:checked + label {
	color: $white;
}

[type='radio']:checked + label:before,
[type='radio']:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border: 1px solid $grey-light;
    border-radius: 20px;
	box-sizing: border-box;
    background: $white;
	transition: $dur $ease;
}

[type='radio']:checked + label:before {
	background: $dodger-blue;
	border: 2px solid $dodger-blue;
}
</style>
